export default function Button({ text, onClick }) {
  return (
    <button
      className="bg-[#ffffff] hover:animate-strobe text-center box-border px-[5px] sm:text-[30px] text-[13px] border-2 border-black"
      onClick={onClick}
    >
      {text}
    </button>
  );
}
